import { render, staticRenderFns } from "./aplicarImpuestos.vue?vue&type=template&id=dc9be37a&"
import script from "./aplicarImpuestos.vue?vue&type=script&lang=js&"
export * from "./aplicarImpuestos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports